import React from 'react';
import { Cloud } from 'lucide-react';

const WeatherPreviewer: React.FC = () => {
    return (
        <div className="w-full h-full flex items-center justify-center p-2">
            <div className="text-center w-full" style={{ fontSize: 'clamp(8px, 1.2vw, 12px)' }}>
                <div className="flex items-center justify-center gap-1 mb-1">
                    <Cloud className="h-3 w-3" />
                    <span>22°C</span>
                </div>
                <div className="text-xs opacity-80">Partly Cloudy</div>
            </div>
        </div>
    );
};

export default WeatherPreviewer;
